(($) => {

	/**
	 * Gulp include scripts
	 *
	 * @link https://www.npmjs.com/package/gulp-include
	 */
	//=require ../../template-parts/blocks/example/block-example.js

	/**
	 * jQuery Document Ready
	 *
	 * @link https://learn.jquery.com/using-jquery-core/document-ready/
	 */
	$(() => {
		// Active failure pop up
		$(document).on('gform_post_render', function(event, formId, currentPage) {
			var $validationMsg = $('#validation_message_1_1');

			if ($validationMsg.length && $.trim($validationMsg.text()) === 'Incorrect code. Please try again.') {
				$('#pop-up-fail').addClass('active');
			}
		});

		// Activate success pop up
		$(document).ready(function() {
			if ($('#gform_confirmation_message_1').length) {
				$('#pop-up-success').addClass('active');
			}
		});

		// On click close pop up
		$(document).on('click', '.pop-up', function() {
			$(this).removeClass('active');
		});
	});

})(jQuery);

// Add active class to forms if input is on focus or has value
const gformInputs = document.querySelectorAll(
    '.js-gform input[type=text], .js-gform input[type=email], .js-gform input[type=tel]'
);

gformInputs.forEach(input => {
    if (input.value.length) {
        input.closest('.gfield').classList.add('active');
    }

    input.addEventListener('focus', () => {
        input.closest('.gfield').classList.add('active');
    });

    input.addEventListener('blur', () => {
        if (!input.value.length || input.value.includes('_')) {
            input.closest('.gfield').classList.remove('active');
        }
    });
});

document.querySelectorAll('.js-gform select').forEach(select => {
    select.addEventListener('change', () => {
        select.closest('.gfield').classList.toggle('active', select.value !== '');
    });
});

// Countdown timer
const target = new Date('2026-04-30T23:59:00').getTime();
const start = Date.now();

function pad(n) {
	return String(n).padStart(2, '0');
}

function tick() {
	const now = Date.now();
	const diff = target - now;
	if (diff <= 0) {
		['d', 'h', 'm', 's'].forEach(id => document.getElementById(id).textContent = '00');
		return;
	}
	const totalSec = Math.floor(diff / 1000);
	document.getElementById('d').textContent = pad(Math.floor(totalSec / 86400));
	document.getElementById('h').textContent = pad(Math.floor((totalSec % 86400) / 3600));
	document.getElementById('m').textContent = pad(Math.floor((totalSec % 3600) / 60));
	document.getElementById('s').textContent = pad(totalSec % 60);
}

tick();
setInterval(tick, 1000);
